export default __webpack_public_path__ + "static/media/forestOfWhimsy.bf7531ba.png";